import React, { Component } from "react";
import { connect } from "react-redux";
import {
    createDeck,
    fetchAvailableQuestions,
    updateHeaderInfo,
    getAllQuestions,
    getUserDetails
} from "../actions";
import { DeckFormWidget, LoadingCard } from "../components";
import { withRouter } from 'react-router-dom';
import { deviceData, makeList, setActiveNavigationWidget } from "../common";

//make state = initial_state
class CreateDeckScreen extends Component {
    state = {
        creationStage: 0,
        deckName: "",
        deckSummary: "",
        areas: "",
        years: "",
        questions: "",
        keywords: [],
        yearObj: [],
        areaObj: [],
        questionObj: [],
        keywordsObj: [],
        ready: false,
        openDeck: true,
        questionCount: 0,
        tracking: null,
        loading: false
    };

    componentDidMount = async () => {
        setActiveNavigationWidget("myDecksFooterIcon");

        await document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});

        this.props.updateHeaderInfo({route:"/createDeckScreen", iconOne: 'home'});

        let newYearObj = [];
        let newAreaObj = [];
        let newKeywordsObj = [];
        this.props.user_details.SASPYears.map(year => {
            if (year.useravailable == 1) {
                newYearObj = { ...newYearObj, [year.ProductYear]: false };
            }
        });

        this.props.user_details.availableAreas.map(area => {
            newAreaObj = { ...newAreaObj, [area.QArea]: false };
        });

        this.props.user_details.availableKeywords.map(keyword => {
            newKeywordsObj = { ...newKeywordsObj, [keyword.keyword]: false };
        });

        const { mcid, key } = this.props.auth_feedback;

        this.setState({
            ...this.state,
            yearObj: newYearObj,
            areaObj: newAreaObj,
            keywordsObj: newKeywordsObj,
            tracking: deviceData(this.props.location, 'navigate') 
        });

        this.props.getUserDetails(mcid, key, deviceData(this.props.location, 'navigate'));

        return this.props.getUserDetails(mcid, key, deviceData(this.props.location, 'navigate'));
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevState !== this.state) {
            if (prevState.yearObj !== this.state.yearObj) {
                this.setState({
                    ready: true
                });
            }

            if (
                prevState.areas !== this.state.areas ||
                prevState.years !== this.state.years
            ) {
                const questionData = {
                    mcid: this.props.auth_feedback.mcid,
                    key: this.props.auth_feedback.key,
                    gamemode: this.state.openDeck ? 3 : 4,
                    yearvar: this.state.years,
                    areavar: this.state.areas
                };

                await this.props.fetchAvailableQuestions(questionData, this.tracking);
            }

            if (prevProps.available_questions !== this.props.available_questions) {
                let newQuestionObj = [];
                await this.props.available_questions.question.map(question => {
                    return (newQuestionObj = {
                        ...newQuestionObj,
                        [question.questionID]: true
                    });
                });

                if (this.state.creationStage < 1) {
                    this.setState({
                        questionObj: newQuestionObj
                    });
                }
            }

            if (prevProps.get_question_count.questionCount != this.props.get_question_count.questionCount) {
                this.setState({
                    ...this.state,
                    questionCount: this.props.get_question_count.questionCount
                });
            }
        }
    };

    render() {
        const INITIAL_STATE = {
            creationStage: 0,
            keywords: "",
            deckName: "",
            deckSummary: "",
            areas: "",
            years: "",
            yearObj: [],
            areaObj: [],
            keywordsObj: [],
            questionObj: [],
            ready: false,
        };

        const getQuestionCount = async (obj) => {
            obj.myYears = makeList(obj.myYears);
            obj.myAreas = makeList(obj.myAreas);
            await this.props.getAllQuestions(obj);
            this.setState({
                ...this.state,
                questionCount: this.props.get_question_count.questionCount
            });

            return this.props.get_question_count.questionCount;
        }

        const sendQuestions = (years, areas, keywords, name, summary = '') => {
            let actualYears = "";
            let actualAreas = "";
            let actualKeywords = "";
            Object.keys(years).forEach((year, index) => {
                if (years[year] == true) {
                    if (index == Object.keys(years).length - 1) {
                        actualYears +=year.toString();
                    } else {
                        actualYears +=year.toString() + ",";
                    }
                }
            });
            
            Object.keys(areas).forEach((area, index) => {
                if (areas[area] == true) {
                    if (index == Object.keys(areas).length - 1) {
                        actualAreas += area.toString();
                    } else {
                        actualAreas += area.toString() + ",";
                    }
                }
            });

            Object.keys(keywords).forEach((keyword, index) => {
                if (keywords[keyword] == true) {
                    if (index == Object.keys(keywords).length - 1) {
                        actualKeywords +=keyword.toString();
                    } else {
                        actualKeywords +=keyword.toString() + ",";
                    }
                }
            });

            this.setState({
                ...this.state,
                years: actualYears,
                areas: actualAreas,
                keywords: actualKeywords,
                deckName: name,
                deckSummary: summary,
                creationStage: 1,
            });
        };

        const nameDeck = name => {
            this.setState({
                ...this.state,
                deckName: name
            });
        };

        const goBack = () => {
            this.setState({
                ...this.state,
                creationStage: this.state.creationStage - 1
            });
        };

        const goHome = () => {
            this.props.history.push('/home');
        }

        const createDeck = async questions => {
            await this.setState({ ...this.state, ready: false });

            let createDeckData = {
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key,
                deckName: this.state.deckName,
                deckPriority: 999,
                deckSummary: this.state.deckSummary,
                isHome: this.state.isHome,
                isSpaced: this.state.isSpaced,
                ispublic: this.state.isPublic,
                gameMode: this.state.openDeck ? 3 : 4,
                tracking: this.state.tracking
            };

            const addQuestions = async questions => {
                let actualQuestions = "";
                Object.keys(questions).forEach((question, index) => {
                    if (questions[question] == true) {
                        if (index == Object.keys(questions).length - 1) {
                            actualQuestions += question.toString();
                        } else {
                            actualQuestions += question.toString() + ",";
                        }
                    } else {
                        if (index == Object.keys(questions).length - 1) {
                            actualQuestions += question.toString();
                        } else {
                            actualQuestions += question.toString() + ",";
                        }
                    }
                });

                this.setState({
                    questions: actualQuestions,
                    // ready: true
                });
            };

            await this.props.createDeck(createDeckData);
            return addQuestions(questions);
        };

        const gapFunc = async (data) => {
            let years = makeList(data.years);
            let areas = makeList(data.areas);
            
            if (data.name == '') { 
                return false; 
            }

            if (typeof data.mode !== 'undefined' && data.mode != null && data.mode != '') { data.mode = 3; }
            if (typeof data.summary !== 'undefined' && data.summary != null) { data.summary = ''; }

            let keywords = makeList(data.keywords);
            let newQuestionObj = [];
            let questionData = {
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key,
                gamemode: data.openDeck == true ? 3 : 4,
                yearvar: years,
                areavar: areas,
                keywords: keywords
            };

            if (!data.blankDeck && (years.length || areas.length)) {
                await this.props.fetchAvailableQuestions(questionData);

                await this.props.available_questions.question.map(question => {
                    return (newQuestionObj = {
                        ...newQuestionObj,
                        [question.questionID]: true
                    });
                });
            }

            await this.setState({
                ...this.state,
                years: years,
                yearObj: data.years,
                areas: areas,
                areaObj: data.areas,
                keywords: keywords,
                keywordObj: data.keywords,
                deckName: data.name,
                deckSummary: data.summary,
                questionObj: newQuestionObj,
                isHome: data.isHome == true ? 1 : 0,
                isPublic: data.isPublic == true ? 1 : 0,
                isSpaced: data.isSpaced == true ? 1 : 0,
                flashCards: data.flashCards == true ? 1 : 0,
                gameMode: data.openDeck == true ? 3 : 4,
                ready: false,
                loading: false,
            }); 

            let createDeckData = {
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key,
                deckName: data.name,
                deckPriority: 999,
                deckSummary: data.summary,
                isHome: data.isHome ? 1 : 0,
                isSpaced: data.isSpaced ? 1 : 0,
                ispublic: data.isPublic ? 1 : 0,
                gameMode: data.openBook ? 3 : 4,
                flashCards: data.flashCardstrue ? 1 : 0,
                blankDeck: years.length == 0 ? true : data.blankDeck,
                tracking: this.state.tracking,
                years: years,
                areas: areas,
                deckEnds: data.deckEnds ? data.deckEnds : 0
            };

            createDeckData.tracking.action = 'created deck';

            await this.props.createDeck(createDeckData);
            goHome();
        }

        const resetForm = () => {
            this.setState({
                INITIAL_STATE
            });
        };

        if (this.state.ready) {
            return (
                <DeckFormWidget
                    keywords={this.state.keywordsObj}
                    nameDeck={nameDeck}
                    name={this.state.deckName}
                    summary={this.state.deckSummary}
                    authorizedyears={this.props.user_details.authorizedyears}
                    SASPYears={this.props.user_details.SASPYears}
                    yearsObj={this.state.yearObj}
                    areaObj={this.state.areaObj}
                    availableAreas={this.props.user_details.availableAreas}
                    goBack={goBack}
                    goHome={goHome}
                    sendQuestions={sendQuestions}
                    resetForm={resetForm}
                    createDeck={createDeck}
                    getQuestionCount={getQuestionCount}
                    user_details={this.props.user_details}
                    gapFunc={gapFunc}
                    questionCount={this.state.questionCount}
                    questions={this.props.available_questions.question}
                    questionObj={this.state.questionObj}
                    icons={this.props.helperIcons}
                />
            );
        } else {
            return (
                <LoadingCard />
            );
        }
    }
}

const mapStateToProps = state => {
    const { user_details, auth_feedback } = state.auth;
    const { newDeckInfo } = state.decks;
    const { available_questions, get_question_count } = state.question;
    const { helperIcons } = state.device;
    return { user_details, auth_feedback, available_questions, newDeckInfo, get_question_count, helperIcons };
};

export default connect(mapStateToProps, {
    fetchAvailableQuestions,
    createDeck,
    updateHeaderInfo,
    getAllQuestions,
    getUserDetails
})(withRouter(CreateDeckScreen));
